import { styled } from '@clickcease/cc-client-components-lib'

export const ChangePasswordInputWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '18px',
  ['&:last-of-type']: {
    marginBottom: '10px',
  },
})

export const ChangePasswordTitle = styled('div', {
  color: '$mainTextColor',
  fontWeight: '$l',
  fontSize: '$md',
  marginBottom: '8px',
})

export const ChangePasswordInputStyled = styled('input', {
  border: '1px solid $buttonPressed',
  borderRadius: '4px',
  width: '250px',
  height: '30px',
  paddingLeft: '12px',
})

export const ShowPassword = styled('img', {
  width: '12px',
  height: '9x',
  position: 'absolute',
  top: '12px',
  right: '0px',
  cursor: 'pointer',
})

export const ShowPasswordAndInputWrapper = styled('div', {
  position: 'relative',
  width: '250px',
})

export const ChangePasswordError = styled('div', {
  width: '100%',
  color: '$error',
  fontWeight: '$l',
  fontSize: '$md',
  textAlign: 'center',
})
